// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Content__Wrapper_2rBGm container","Block":"Content__Block_SULYI","ColLeft":"Content__ColLeft_2tw7D"};